/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
import React from 'react';
import { connect } from 'react-redux';
import {
  fetchNotesByStudyGidAndParticipantId,
  fetchNotesPdfByStudyGidAndParticipantId,
  showModal
} from '../../actions/actions';
import NotesComponent from './notes.component';
import { ADD_NOTE } from '../../const.js';
import DateHelper from '../../helper/date';
import { MODAL_TYPE_ADD_NOTE } from '../../constants/modalTypes';
import SubjectService from '../subject/subject.service';
import RequestService from '../../service/requestService';

export const mapStateToProps = (state, ownProps) => {
  let [timezone] = SubjectService.getSiteTimezone(state.subject.participantSites);
  return {
    studyGid: state.notes.studyGid,
    participantId: state.notes.participantId,
    reporter: state.login.user,
    newNoteAdded: state.newNote.noteSuccess,
    timezone
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    loadData: (studyGid, participantId) => {
      return RequestService.getNotesByStudyGidAndParticipant(studyGid, participantId);
    },
    createNewNote: (user) => {
      dispatch(
        showModal(MODAL_TYPE_ADD_NOTE, {
          shouldCloseOnOverlayClick: false,
          title: ADD_NOTE,
          details: DateHelper.timestampToHumanReadableString(new Date()) + ', ' + user.firstName + ' ' + user.lastName,
          className: 'add-note-modal'
        })
      );
    },
    fetchNotesPdf: (studyGid, participantId) => {
      dispatch(fetchNotesPdfByStudyGidAndParticipantId(studyGid, participantId));
    }
  };
};

const NotesContainer = connect(mapStateToProps, mapDispatchToProps)(NotesComponent);

export default NotesContainer;
